import { create } from 'zustand';

import { ApiProfileSimpleResponse } from '@/shared/api';

type BeneficiaryState = {
  data: ApiProfileSimpleResponse[] | null;
  isLoading: boolean;
};

type BeneficiaryStore = BeneficiaryState & {
  setData: (data: ApiProfileSimpleResponse[] | null) => void;
  setIsLoading: (isLoading: boolean) => void;
  reset: () => void;
};

const getInitialData = (): BeneficiaryState => ({
  data: null,
  isLoading: true,
});

export const useBeneficiariesStore = create<BeneficiaryStore>((set) => ({
  ...getInitialData(),
  setData: (data) => set({ data, isLoading: false }),
  setIsLoading: (isLoading) => set({ isLoading }),
  reset: () => set(getInitialData()),
}));
